import React from 'react';
import { Spinner } from '@nextui-org/react';

export default function LoadingScreen() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: 'linear-gradient(135deg, #0a1628 0%, #1a3a6b 100%)',
      gap: '16px'
    }}>
      <svg width={72} height={72} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" style={{ animation: 'pulse 2s ease-in-out infinite' }}>
        <circle cx="100" cy="100" r="98" fill="white" stroke="#1a237e" strokeWidth="3.5"/>
        <circle cx="100" cy="100" r="91" fill="white" stroke="#E65100" strokeWidth="2"/>
        <g fill="#2E7D32">
          <ellipse cx="30" cy="100" rx="4" ry="9" transform="rotate(-30 30 100)"/>
          <ellipse cx="22" cy="82" rx="4" ry="9" transform="rotate(-20 22 82)"/>
          <ellipse cx="170" cy="100" rx="4" ry="9" transform="rotate(30 170 100)"/>
          <ellipse cx="178" cy="82" rx="4" ry="9" transform="rotate(20 178 82)"/>
        </g>
        <path d="M55 128 Q100 122 145 128 L148 144 Q100 150 52 144 Z" fill="#1565C0"/>
        <text x="100" y="140" textAnchor="middle" fontSize="11" fill="white" fontFamily="Arial" fontWeight="bold">उत्तर प्रदेश</text>
        <circle cx="100" cy="80" r="7" fill="#1565C0"/>
        <path d="M92 88 Q100 95 108 88 L112 115 Q100 120 88 115 Z" fill="#1565C0"/>
      </svg>
      <Spinner size="lg" color="warning" />
      <p style={{ color: '#ffa000', fontFamily: 'Baloo 2, sans-serif', fontWeight: 600, fontSize: '1rem' }}>
        SAMBAL Charitable Trust
      </p>
      <p style={{ color: '#90a4ae', fontSize: '0.8rem' }}>Loading...</p>
    </div>
  );
}
